import { HttpClient } from '@angular/common/http'
import { Component } from '@angular/core'
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  PopoverController,
  ViewController
} from 'ionic-angular'
import * as moment from 'moment/moment.js'
import { Observable } from 'rxjs/Observable'

import { RdkDatePickerComponent } from '../../components/rdk-date-picker/rdk-date-picker'
import { Contact, Deal, DealStatus, Meeting, User } from '../../models/models'
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth'
import { ApiProvider } from '../../providers/api/api'
import { OperatorProvider } from '../../providers/operator/operator'
import { SettingsProvider } from '../../providers/settings/settings'

/**
 * Generated class for the AddMeetingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-add-meeting',
  templateUrl: 'add-meeting.html',
})
export class AddMeetingPage {
  title = "Aggiungi Appuntamento"
  contact: Contact
  meetingDate: moment.Moment
  meetingTime
  meetingPlace: string
  meetingNotes: string
  silent: boolean
  deal: Deal
  operator_id: number

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: ApiProvider, private modalCtrl: ModalController, private popoverCtrl: PopoverController, private viewController: ViewController, private alertCtrl: AlertController, public http: HttpClient, private loading: LoadingController, private operatorProvider: OperatorProvider, private settings: SettingsProvider, private userAuth: UserAuthProvider<User>) {
    this.silent = (navParams && navParams.get('silent')) || false
    this.contact = (navParams && navParams.get('contact')) || null
    this.deal = (navParams && navParams.get('deal')) || null

    this.meetingPlace = (navParams && navParams.get('place')) || null
    this.meetingNotes = (navParams && navParams.get('notes')) || null

    if (this.deal) {
      this.title = "Ricrea Appuntamento"
    }

    this.operatorProvider.currentOperator.subscribe(operator => {
      if (operator) {
        this.operator_id = operator.id
      }
    })
  }

  selectDate(event) {
    let now = this.meetingDate ? this.meetingDate : moment().hour(0).minute(0).second(0)
    let __this = this
    var datePicker = new RdkDatePickerComponent(this.modalCtrl, this.popoverCtrl, this.viewController, new NavParams({ currentMoment: now }));
    datePicker.onDateSelected.subscribe(function (date) {
      __this.meetingDate = date.momentDate;
    });
    datePicker.showCalendar(event);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddMeetingPage');
  }

  close() {
    this.viewController.dismiss(null);
  }

  createMeeting() {
    if (this.meetingDate && this.meetingTime) {
      this.meetingDate.set('hour', this.meetingTime.split(":")[0])
      this.meetingDate.set('minute', this.meetingTime.split(":")[1])
      let meeting: Meeting = {
        schedule_datetime: this.meetingDate.toISOString(),
        deal: this.deal,
        operator: this.operator_id,
        place: this.meetingPlace,
        notes: this.meetingNotes,
      }
      let l = this.loading.create({
        content: "Attendere.."
      })
      l.present()

      this.api.postMeeting(this.operator_id, meeting)
        .concatMap(_meeting => {
          if (this.deal.status === DealStatus.WON) {
            throw new Error('Deal Gia Vinto')
          }
          this.deal.current_pipeline = this.settings.PIPELINE_VENDITA_BY_PRODUCT[this.deal.product.ac_label]
          this.deal.current_stage = this.settings.STAGE_APPOINTMENT_TODO_BY_PRODUCT[this.deal.product.ac_label]
          this.deal.status = this.settings.DEAL_OPEN
          return this.api.patchDeal(this.deal)
        })
        .concatMap(_deal => {
          return this.postMeetingOnAc(this.contact, this.userAuth.currentUser, this.meetingDate.format("YYYY-MM-DD"), this.meetingTime, this.meetingPlace)
            .catch(e => {
              return Observable.of(e.status == '200')
            })
        })
        .subscribe(_x => {
          l.dismiss()
          if (this.silent) {
            this.viewController.dismiss(this.meetingDate)
          } else {
            this.alertCtrl.create({
              title: "Apputamento Creato",
              message: "Appuntamento creato correttamente",
              buttons: [
                {
                  text: 'Ok',
                  handler: () => {
                    this.viewController.dismiss(this.meetingDate);
                  }
                },
              ]
            }).present()
          }
        }, _e => {
          l.dismiss()

          this.alertCtrl.create({
            title: "Attenzione",
            message: "Si è verificato un errore durante la creazione dell'appuntamento",
            buttons: [
              {
                text: 'Annulla',
                handler: () => {
                  this.viewController.dismiss(null);
                }
              },
              {
                text: 'Riprova',
                handler: () => {
                  this.createMeeting()
                }
              },
            ]
          }).present()

        })
    } else {
      this.alertCtrl.create({
        title: "Attenzione",
        message: "Inserisci una data e orario corretta per continuare",
        buttons: [
          {
            text: 'Ok',
            handler: () => { }
          },
        ]
      }).present()
    }
  }

  // postOnAc(contact_email: string, operator_email: string, meeting_date: string, meeting_time: string) {
  //   let url = "https://mypushop.activehosted.com/proc.php?u=9&f=9&s=&c=0&m=0&act=sub&v=2&jsonp=true"
  //     + "&email=" + contact_email
  //     + "&fullname=" + ""
  //     + "&field[27]=" + operator_email
  //     + "&field[2]=" + meeting_date
  //     + "&field[7]=" + meeting_time
  //     + "&field[16]=" + meeting_date
  //     + "&field[17]=" + meeting_time
  //   return this.http.post<any>(url, {})
  // }

  postMeetingOnAc(contact: Contact, user: User, meeting_date: string, meeting_time: string, meeting_place: string) {
    let url = "https://mypushop.activehosted.com/proc.php?u=37&f=37&s=&c=0&m=0&act=sub&v=2&jsonp=true"
      + "&email=" + contact.email
      + "&field[41]=" + contact.company // business name
      + "&field[4]=" + user.firstname // mypushop seller name
      + "&field[26]=" + user.firstname + " " + user.surname // MYP_OPERATORNAME
      + "&field[27]=" + user.email // MYP_OPERATOREMAIL
      + "&field[28]=" + user.phone // MYP_OPERATORPHONE
      + "&field[17]=" + meeting_time // Next Appointment Time
      + "&field[16]=" + meeting_date //Next Appointment Date
      + "&field[19]=" + meeting_place //Next Appointment Place
      + "&field[2]=" + meeting_date
      + "&field[7]=" + meeting_time
    return this.http.post<any>(url, {})
  }

}




// WEBPACK FOOTER //
// ./src/pages/add-meeting/add-meeting.ts